<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import AuditTrailListItem from './AuditTrailListItem.vue';

defineProps({
  records: { type: Array, required: true },
});

const { t } = useI18n();

const activeRecordId = ref(null);

const handleToggle = id => {
  activeRecordId.value = activeRecordId.value === id ? null : id;
};
</script>

<template>
  <div class="overflow-hidden bg-n-solid-2 rounded-2xl shadow mx-6 mt-4 mb-6">
    <div class="divide-y divide-n-weak">
      <div class="px-6 py-4 hover:bg-n-solid-1 transition-colors duration-200">
        <div
          class="grid grid-cols-[1fr_0.5fr_1fr_1fr_0.5fr_auto] gap-4 text-sm"
        >
          <div class="text-sm font-medium text-n-slate-12">
            {{ t('WGPT_AUDIT_TRAIL.LIST.TABLE_HEADER.TIMESTAMP') }}
          </div>
          <div class="text-sm font-medium text-n-slate-12">
            {{ t('WGPT_AUDIT_TRAIL.LIST.TABLE_HEADER.ACTION') }}
          </div>
          <div class="text-sm font-medium text-n-slate-12">
            {{ t('WGPT_AUDIT_TRAIL.LIST.TABLE_HEADER.MODEL') }}
          </div>
          <div class="text-sm font-medium text-n-slate-12">
            {{ t('WGPT_AUDIT_TRAIL.LIST.TABLE_HEADER.USER') }}
          </div>
          <div class="text-sm font-medium text-n-slate-12">
            {{ t('WGPT_AUDIT_TRAIL.LIST.TABLE_HEADER.IP') }}
          </div>
          <div class="min-w-6" />
        </div>
      </div>

      <div
        v-for="record in records"
        :key="record.id"
        class="px-6 py-4 hover:bg-n-solid-1 transition-colors duration-200"
      >
        <AuditTrailListItem
          :record="record"
          :is-expanded="activeRecordId === record.id"
          @toggle="handleToggle(record.id)"
        />
      </div>
    </div>
  </div>
</template>
